import { ArticleProps } from "../../../../redux/slices/article/Article";
import Audio from "./audio";
import Image from "./image";
import Poll from "./poll";
import Slider from "./slider";
import Text from "./text";
import Video from "./video";

export const renderContent = (props: ArticleProps.Content) => {
  const id = props?.id ?? 0;

  switch (props?.content_type_desc ?? "") {
    case "image":
      return <Image id={id} />;
    case "video":
      return <Video id={id} />;
    case "audio":
      return <Audio id={id} />;
    case "poll":
      return <Poll id={id} />;
    case "rating":
      return <Slider id={id} />;
    case "text":
      return <Text id={id} />;
    default:
      return null;
  }
};
